import API from './axios.js';

export const getInvoicesCompany = (queryParams = '') => API.get(`invoice/created-by-company${queryParams}`);
export const getInvoicesCustomer = (queryParams = '') => API.get(`invoice/created-for-customer${queryParams}`);

export const addInvoiceCompany = (payload) => API.post('invoice',payload);
// REPLACE your existing updateInvoiceStatus function with this:
export const updateInvoiceStatus = (id, status, cancellationRemark = "") => {
  let url = `invoice/status/${id}?status=${status}`;
  
  // Add cancellation remark to URL if provided
  if (status === "cancelled" && cancellationRemark && cancellationRemark.trim()) {
    url += `&cancelRemark=${encodeURIComponent(cancellationRemark.trim())}`;
  }
  
  return API.patch(url);
};


export const InvoicePaymentDetails = (id,payload) => API.patch(`invoice/${id}/add-payment`,payload);



export const getInvoicesByID= (id) => API.get(`invoice/${id}`);

export const sendEmailByStatus = (status) => API.post(`invoice/send-email-by-status/${status}`);
export const sendEmailByInvoiceID = (payload) => API.post(`invoice/send-email-by-invoice-ids`,payload);
export const getInvoicesByClientId = (clientId) => API.get(`invoice/by-client-id/${clientId}`);